import { render, staticRenderFns } from "./DOTS.vue?vue&type=template&id=11d4a453"
import script from "./DOTS.vue?vue&type=script&lang=js"
export * from "./DOTS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports